// export const email_reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
export const email_reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
export const colorReg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
export const number_reg = /^(([^0][0-9]+|0)$)|^(([1-9]+)$)/;
export const number_decimal_reg = /^(?!0\d)\d*(\.\d+)?$/;